export const printHtmlInNewTab = (bodyHtml: string, bodyStyles?: string) => {
	const styleTag = bodyStyles ? `<style>${bodyStyles}</style>` : "";
	const fullHtml = `<!DOCTYPE html><html><head><title></title>${styleTag}</head><body>${bodyHtml}<script>window.addEventListener("load",function(){setTimeout(function(){window.print();},0);});</script></body></html>`;

	const blob = new Blob([fullHtml], { type: "text/html" });
	const url = URL.createObjectURL(blob);
	const printWindow = window.open(url, "_blank");
	if (!printWindow) {
		URL.revokeObjectURL(url);
		return;
	}
	// Revoke the blob URL once the new tab has loaded it. We can't rely on
	// a `load` listener on `printWindow` (cross-origin once the blob URL
	// commits), so fall back to a short timeout.
	setTimeout(() => {
		URL.revokeObjectURL(url);
	}, 10_000);
};
